import { cn } from '@/utils/index'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-neutral-200/50", className)} {...props} />
}

export { Skeleton }
